import React from 'react';
export const Footer = () => {
  return <footer className="bg-[#111429] text-white py-16 relative overflow-hidden" data-id="element-130">
      <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-[#171b31] to-transparent z-10" data-id="element-131"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] gradient-circle opacity-10" data-id="element-132"></div>
      <div className="absolute top-0 right-0 w-[400px] h-[400px] gradient-circle opacity-10" data-id="element-133"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-134">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-135">
          <div className="md:col-span-1" data-id="element-136">
            <a href="#" className="flex items-center" data-id="element-137">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2hdfmJveDkd4qR1c9E26iB/munis_verse_blue_logo.jpg" alt="MUNISVerse Logo" className="h-12 w-12 mr-2 rounded-full logo-glow" data-id="element-138" />
              <span className="text-2xl font-bold ml-1" data-id="element-139">
                MUNIS<span className="text-gradient font-extrabold" data-id="element-140">Verse</span>
              </span>
            </a>
            <p className="mt-4 text-gray-400" data-id="element-141">
              Revolutionizing real estate experiences through immersive virtual
              reality technology.
            </p>
          </div>
          <div data-id="element-142">
            <h3 className="text-lg font-semibold mb-4 text-[#30c5e8]" data-id="element-143">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-144">
              <li data-id="element-145">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-146">
                  Home
                </a>
              </li>
              <li data-id="element-147">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-148">
                  About Us
                </a>
              </li>
              <li data-id="element-149">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-150">
                  Services
                </a>
              </li>
              <li data-id="element-151">
                <a href="#how-it-works" className="text-gray-400 hover:text-white transition-colors" data-id="element-152">
                  How It Works
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-153">
            <h3 className="text-lg font-semibold mb-4 text-[#a64cff]" data-id="element-154">
              Services
            </h3>
            <ul className="space-y-2" data-id="element-155">
              <li data-id="element-156">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-157">
                  VR Property Tours
                </a>
              </li>
              <li data-id="element-158">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-159">
                  Digital Showrooms
                </a>
              </li>
              <li data-id="element-160">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-161">
                  Relocation Assistance
                </a>
              </li>
              <li data-id="element-162">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-163">
                  Investment Advisory
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-164">
            <h3 className="text-lg font-semibold mb-4 text-[#b78aff]" data-id="element-165">
              Contact
            </h3>
            <ul className="space-y-2 text-gray-400" data-id="element-166">
              <li data-id="element-167">15 Victoria Island Boulevard</li>
              <li data-id="element-168">Lagos, Nigeria</li>
              <li data-id="element-169">+234 903 705 9783</li>
              <li data-id="element-170">info@munisverse.com</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[rgba(255,255,255,0.1)] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-171">
          <p className="text-gray-400 text-sm" data-id="element-172">
            © {new Date().getFullYear()} MUNISVerse. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-173">
            <a href="https://www.instagram.com/munis_verse?igsh=MTF2Z2xxY2swZjlocQ%3D%3D&utm_source=qr" className="text-gray-400 hover:text-[#a64cff] transition-colors" data-id="element-174">
              <span className="sr-only" data-id="element-175">Instagram</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-176">
                <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-177"></path>
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-[#30c5e8] transition-colors" data-id="element-178">
              <span className="sr-only" data-id="element-179">Twitter</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-180">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-181"></path>
              </svg>
            </a>
            <a href="https://www.linkedin.com/in/bukola-m-a87aa5213/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" className="text-gray-400 hover:text-[#b78aff] transition-colors" data-id="element-182">
              <span className="sr-only" data-id="element-183">LinkedIn</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-184">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-185"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
};